/** biome-ignore-all lint/nursery/useExplicitType: Zod schema inference */
import { PERSON_CREDIT_ROLES } from '@repo/config';
import { z } from 'zod';

export const personCreditRoleSchema = z.enum(PERSON_CREDIT_ROLES);

export const collectionCreditSchema = z.object({
  id: z.number(),
  personId: z.number(),
  role: personCreditRoleSchema,
  department: z.string().nullable().optional(),
  job: z.string().nullable().optional(),
  characterName: z.string().nullable().optional(),
  creditPhotoPath: z.string().nullable().optional(),
  sortOrder: z.number(),
  personName: z.string(),
  personSlug: z.string(),
  personAvatarPath: z.string().nullable().optional(),
  avatarUrl: z.string().nullable().optional(),
});

export const filmographyCreditSchema = z.object({
  id: z.number(),
  collectionId: z.number(),
  role: personCreditRoleSchema,
  characterName: z.string().nullable().optional(),
  creditPhotoPath: z.string().nullable().optional(),
  sortOrder: z.number(),
  collectionTitle: z.string(),
  collectionSlug: z.string(),
  collectionType: z.string(),
  collectionYear: z.number().nullable().optional(),
  collectionPosterPath: z.string().nullable().optional(),
  collectionTitleInPoster: z.number().nullable().optional(),
  collectionStatus: z.string(),
});

export type ICollectionCredit = z.infer<typeof collectionCreditSchema>;
export type IFilmographyCredit = z.infer<typeof filmographyCreditSchema>;
